<template>
    <div>
        <label class="w-full"> Descrição </label>
        <vs-input class="w-full mb-6" v-model="description" />

        <label class="w-full"> Detalhes </label>
        <vs-textarea v-model="details" />
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        computed : {
            description : {
                get () {
                    return this.productInfo.description
                },
                set (description) {
                    this.setDescription(description)
                }
            },

            details : {
                get () {
                    return this.productInfo.details
                },
                set (details) {
                    this.setDetails(details)
                } 
            },

            ...mapState('product', ['productInfo'])
        },

        methods : {
            ...mapMutations('product', ['setName', 'setDescription', 'setDetails'])
        }
    }
</script>